export default "__VITE_ASSET__Bfr_sUst__"